/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignatureBlock
 */
export interface SignatureBlock {
    /**
     * 
     * @type {number}
     * @memberof SignatureBlock
     */
    leftCellWidthInches?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SignatureBlock
     */
    rightCellWidthInches?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SignatureBlock
     */
    middleCellWidthInches?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SignatureBlock
     */
    leftCellHTML?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SignatureBlock
     */
    rightCellHTML?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SignatureBlock
     */
    middleCellHTML?: string | null;
}

export function SignatureBlockFromJSON(json: any): SignatureBlock {
    return SignatureBlockFromJSONTyped(json, false);
}

export function SignatureBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignatureBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'leftCellWidthInches': !exists(json, 'leftCellWidthInches') ? undefined : json['leftCellWidthInches'],
        'rightCellWidthInches': !exists(json, 'rightCellWidthInches') ? undefined : json['rightCellWidthInches'],
        'middleCellWidthInches': !exists(json, 'middleCellWidthInches') ? undefined : json['middleCellWidthInches'],
        'leftCellHTML': !exists(json, 'leftCellHTML') ? undefined : json['leftCellHTML'],
        'rightCellHTML': !exists(json, 'rightCellHTML') ? undefined : json['rightCellHTML'],
        'middleCellHTML': !exists(json, 'middleCellHTML') ? undefined : json['middleCellHTML'],
    };
}

export function SignatureBlockToJSON(value?: SignatureBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'leftCellWidthInches': value.leftCellWidthInches,
        'rightCellWidthInches': value.rightCellWidthInches,
        'middleCellWidthInches': value.middleCellWidthInches,
        'leftCellHTML': value.leftCellHTML,
        'rightCellHTML': value.rightCellHTML,
        'middleCellHTML': value.middleCellHTML,
    };
}


